var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonBackground = function SvgPersonBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#015C92",
    d: "M21.05 11c4.918.104 5.476 3.458 4.427 7.328.164.103.5.472.444 1.09-.165 1.135-.663 1.445-.938 1.445-.111.773-.502 1.588-.889 2.104-.276.361-.379.826-.379 1.29 0 .413-.006.15.05.615q.084.223.23.415c-.113.397-.765 2.289-2.995 2.289-2.283 0-2.897-2.041-2.962-2.29q.154-.189.247-.414c.055-.567.065-.303.065-.768 0-.413-.173-.766-.395-1.075-.386-.517-.76-1.393-.872-2.166-.333 0-.827-.31-.938-1.445-.056-.618.206-.987.428-1.09-.553-1.444-1.594-5.926 1.942-6.39.387-.62 1.319-.938 2.534-.938m-3.885 14.978c.443 1.098 1.613 2.58 3.835 2.58 2.224 0 3.39-1.455 3.851-2.565C27.04 27.251 31.5 27.637 31.5 32h-21c0-4.474 4.44-4.782 6.665-6.022"
  })));
};
export default SvgPersonBackground;